// extracted by mini-css-extract-plugin
export var arrowArea = "featurehubcard-module--arrowArea--d4e54";
export var arrowIcon = "featurehubcard-module--arrowIcon--c08ac";
export var cardWrapper = "featurehubcard-module--cardWrapper--f4d64";
export var content = "featurehubcard-module--content--8ed5f";
export var iconArea = "featurehubcard-module--iconArea--b0a39";
export var mainIcon = "featurehubcard-module--mainIcon--4fbff";
export var subTitle = "featurehubcard-module--subTitle--21515";
export var textArea = "featurehubcard-module--textArea--8e39e";
export var title = "featurehubcard-module--title--66cc5";